import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Input,
  FormGroup,
  Col,
  Row,
  Container,
  Label,
} from "reactstrap";
import "./index.css";
import FromNow from "components/Time/FromNow";
import ApiCaller from "api/apiCaller";
import { TransformationRunLog } from "model/transformation";
import SyntaxHighlighter from "react-syntax-highlighter";
import { docco } from "react-syntax-highlighter/dist/esm/styles/hljs";

interface TransformationRunLogItemProps {
  transformationRunLog: TransformationRunLog;
}

export default function TransformationRunLogItem({
  transformationRunLog,
}: TransformationRunLogItemProps) {
  const [showSQLView, setShowSQLView] = useState<boolean>(false);
  const getRowIcon = (runLog:TransformationRunLog) => {
    let iconToDisplay:string = 'stop_circle'
    if (runLog.status === 'success') {
      iconToDisplay = 'check_circle';
    }
    if (runLog.status === 'running') {
      iconToDisplay = 'play_circle_filled';
    }
    if (runLog.status === 'failed') {
      iconToDisplay = 'cancel';
    }
    return iconToDisplay;
  }
  const toogleSQLView = () => {
    setShowSQLView(!showSQLView);
  }
  return (
    <tr>
      <td className={`transformation-run-log-table__status ${transformationRunLog.status}`}>
        <i className="material-icons">
          {getRowIcon(transformationRunLog)}
        </i>
      </td>
      <td>{transformationRunLog.id}</td>
      <td>
        {transformationRunLog.message &&
          <p>{transformationRunLog.message}</p>
        }
        <div>
          <Button
            size="sm"
            color="secondary"
            onClick={toogleSQLView}
          >{showSQLView ? 'Hide' : 'Show'} SQL</Button>
        </div>
        {showSQLView &&
          <div style={styles.sqlView}>
            <SyntaxHighlighter
              language="sql"
              style={docco}
            >
              {transformationRunLog?.sql || ""}
            </SyntaxHighlighter>
          </div>
        }
      </td>
      <td>{transformationRunLog.duration}s</td>
      <td>
        <FromNow value={transformationRunLog.end_time} />
      </td>
    </tr>
  );
}

const styles: { [name: string]: React.CSSProperties } = {
  sqlView: {
    marginTop: 12,
  }
};
